export enum PlatformEnum {
  Iphone = 'iphone',
  Ipad = 'ipad',
  Android = 'android',
}

export enum OrientationEnum {
  Vertical = 1,
  Horizontal = 2,
  Auto = 3,
}

export const deviceConfig: {
  [key in PlatformEnum]: {
    cover: {
      width: number
      height: number
    }
    screen: [number, number]
  }
} = {
  iphone: {
    cover: {
      width: 406,
      height: 825,
    },
    screen: [375, 667],
  },
  ipad: {
    cover: {
      width: 658,
      height: 1053 * 0.9,
    },
    screen: [
      768 * 0.8,
      1024 * 0.8, // 921
    ],
  },
  android: {
    cover: {
      width: 508,
      height: 1028,
    },
    screen: [470, 840],
  },
}
